/*
•⁠  ⁠Responsable de Projet
•⁠  ⁠Chef d'Equipe 
•⁠  ⁠Chef de Poste
•⁠  ⁠Gros Bras
•⁠  ⁠Garde Arme 
•⁠  ⁠Agent Simple
•⁠  ⁠Maitre-chien 
•⁠  ⁠OTS
•⁠  ⁠Pompier
•⁠  ⁠Autre

*/

/*










*/

let contractTypesForSite = [
  { value: "PROJECT_MANAGER", label: "⁠Responsable de Projet" }, //⁠Agent Simple

  { value: "TEAM_LEADER", label: "⁠Chef d'Equipe" }, //⁠Chef d'Equipe
  { value: "HEAD_OF_STATION", label: "Chef de Poste" }, //⁠Chef de Poste
  //

  { value: "BIG_ARMS", label: "Gros Bras" }, //•⁠  ⁠Gros Bras
  { value: "BIG_ARMS_SINTO", label: "Gros Bras (Sinto)" },
  { value: "ARMED_GUARD", label: "⁠Garde Arme" }, //⁠Garde Arme

  { value: "STANDARD_SECURITY_GUARD", label: "Agent Simple" }, //⁠Agent Simple

  { value: "DOG_HANDLER", label: "⁠Maitre-chien" }, //⁠Maitre-chien
  //

  {
    value: "CCTV_OPERATOR",
    label: "OTS", //⁠OTS / Opérateur de Télésurveillance
  }, //OTS

  //

  {
    value: "MANAGING_DIRECTOR",
    label: "DIRECTEUR GENERAL", //⁠OTS / Opérateur de Télésurveillance
  },

  {
    value: "CCTV_OPERATOR_PES",
    label: "OTS (PES)", //⁠OTS / Opérateur de Télésurveillance
  }, //OTS

  { value: "FIREFIGHTER", label: "Pompier" }, // ⁠Pompier

  { value: "OTHER", label: "Autre" }, //⁠Autre

  //New Types Added For Migration

  { value: "SECURITY_AGENT", label: "⁠AGENT DE SECURITE" },
  { value: "SECURITY_AGENT_PES", label: "⁠AGENT DE SECURITE (PES)" },
  { value: "SECURITY_AGENT_GA", label: "⁠AGENT DE SECURITE (GA)" },
  { value: "SECURITY_AGENT_COSTUMER", label: "⁠AGENT DE SECURITE (COSTUME)" },
  { value: "SECURITY_AGENT_PATROLLER", label: "AGENT DE SECURITE (RONDIER)" },
  //
  {
    value: "SECURITY_OFFICER_DEPUTY_CHIEF",
    label: "⁠AGENT DE SECURITE SOUS CHEF",
  },
  { value: "RESPONDER", label: "⁠INTERVENANT" },
  { value: "RESPONDER_AND_DRIVER", label: "⁠INTERVENANT CHAUFFEUR" },
  { value: "RESPONDER_AND_LEADER", label: "INTERVENANT - CHEF D'EQUIPE" },

  //
  { value: "SUPERVISOR", label: "⁠SUPERVISEUR" },
  //
  { value: "SUPERVISOR_WEAPONS", label: "SUPERVISEUR ARMEMENT" },

  { value: "TECHNICIAN", label: "⁠TECHNICIEN" },
  { value: "RADIO_OPERATOR", label: "⁠⁠OPERATEUR RADIO " },
  { value: "⁠⁠COMMERCIAL", label: "Commercial" },
  { value: "ASSISTANT_HR", label: "ASSISTANTE RH" },

  /*

    AGENT POMPIER -> POMPIER
    ASSISTANT RH -> ASSISTANTE RH
    AGENT DE SECURITE GROS BRAS -> Gros Bras
    DIRECTEUR DES OPERATIONS -> DIRECTEUR D'EXPLOITATION
    AGENT DE SECURITE AGENT CYNOPHILE
     AGENT DE SECURITE (CHEF DE POSTE) -> CHEF DE POSTE
     AGENT DE SECURITY ->  AGENT DE SECURITE
     AGENT DEC SECURITE -> AGENT DE SECURITE
     AGENT DE SECUTE -> AGENT DE SECURITE
     AGENT DE SECURITE (CHEF DE POSTE) -> CHEF DE POSTE
  */

  /*

    "AGENT POMPIER": "FIREFIGHTER",
    "ASSISTANT RH": -> "ASSISTANT_HR",
    "AGENT DE SECURITE GROS BRAS":  "BIG_ARMS",
    "DIRECTEUR DES OPERATIONS":  "DIRECTOR_OF_OPERATION",
    "AGENT DE SECURITE AGENT CYNOPHILE": "DOG_HANDLER",
     "AGENT DE SECURITE (CHEF DE POSTE)": "HEAD_OF_STATION",
     "AGENT DE SECURITY" :  "SECURITY_AGENT",
     "AGENT DEC SECURITE" : "SECURITY_AGENT",
     "AGENT DE SECUTE" : "SECURITY_AGENT",
     "AGENT DE SECURITE (CHEF DE POSTE)" : "HEAD_OF_STATION",
  */

  //
  { value: "SITE_MANAGER", label: "RESPONSABLE SITE" },
  { value: "HEAD_OF_STATION_ASSISTANT", label: "CHEF DE POSTE ADJOINT" },
  { value: "ACCOUNTANT", label: "COMPTABLE" },
  { value: "DIRECTOR_OF_HR", label: "DIRECTRICE DES RESSOURCES HUMAINES" },
  { value: "MOTORCYCLE_MECHANIC", label: "MECANICIEN MOTO" },

  { value: "CONSULTING_ACCOUNTANT", label: "COMPTABLE CONSULTANT" },

  { value: "MANAGING_DIRECTOR_ASSISTANT", label: "DIRECTEUR GENERAL ADJOINT" },
  { value: "DIRECTOR_OF_OPERATION", label: "DIRECTEUR D'EXPLOITATION" },

  { value: "TREASURY_ASSISTANT", label: "ASSISTANTE TRESORERIE" },

  {
    value: "SECURITY_AGENT_AND_DOG_HANDLER",
    label: "AGENT DE SECURITE AGENT CYNOPHILE",
  },

  {
    value: "CLAIMS_AND_TRAINING_MANAGER",
    label: "RESPONSABLE SINISTRE ET FORMATION",
  },

  { value: "TRAINER", label: "FORMATEUR" },

  {
    value: "ASSISTANT_DIRECTOR_OF_OPERATIONS",
    label: "ADJOINT DIRECTEUR DES OPERATIONS",
  },
  { value: "LEGAL_ADVISOR", label: "JURISTE" },
  { value: "ASSISTANT_HR", label: "AGENT DE SECURITE (CHEF DE POSTE)" },
  { value: "HR_AND_LEGAL_ASSISTANT", label: "ASSISTANTE RH ET JURIDIQUE" },
  { value: "OFF_SITE_SUPERVISOR", label: "SUPERVISEUR DETACHE" },
  { value: "ACCOUNTING_INTERN", label: "STAGIAIRE COMPTABLE" },

  { value: "AGENT_COSTUME", label: "AGENT COSTUME" },
  { value: "SURFACE_TECHNICIAN", label: "TECHNICIENE DE SURFACE" },
  { value: "DELIVERY_PERSON", label: "COURSIER" },
];

export default contractTypesForSite;
